export * from './email-match';
export * from './hashtag-match';
export * from './match';
export * from './mention-match';
export * from './phone-match';
export * from './url-match';

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/autolinker/dist/es2015/match/index.js
// module id = 961
// module chunks = 0